import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DoadorCreditoService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) { }

  /**
* Cria um novo reembolso
* @param reembolso
* @returns Observable<any>
*/
  public store(reembolso: any): Observable<any> {
    return this.apiService.post(`/DoadorCredito`, reembolso);
  }

}
